/**
 * Vendor
 */

/**
 * CARIBE7 MODULES
 */
import BaseService  from '@shared/services/base/BaseService'
import EVENT_NAMES  from '@shared/lib/constants/events';

import InfoAlertService from '@shared/services/base/alerts/traits/InfoAlertService';
import ErrorAlertService from '@shared/services/base/alerts/traits/ErrorAlertService';
import SuccessAlertService from '@shared/services/base/alerts/traits/SuccessAlertService';
import QuestionAlertService from '@shared/services/base/alerts/traits/QuestionAlertService';
import WarningAlertService from '@shared/services/base/alerts/traits/WarningAlertService';
import LoadingAlertService from '@shared/services/base/alerts/traits/LoadingAlertService';

/**
 * Alert Service
 *
 * @class      AlertService (name)
 */
function AlertService(component) {
  this.component   = component;
  this.event_group = EVENT_NAMES.ALERT;
  this.defaults_props = {
    showCloseButton: true,
    timer: 6000,
  };
}

AlertService.prototype = Object.assign(AlertService.prototype, BaseService.prototype);
AlertService.prototype = Object.assign(AlertService.prototype, InfoAlertService.prototype);
AlertService.prototype = Object.assign(AlertService.prototype, ErrorAlertService.prototype);
AlertService.prototype = Object.assign(AlertService.prototype, SuccessAlertService.prototype);
AlertService.prototype = Object.assign(AlertService.prototype, QuestionAlertService.prototype);
AlertService.prototype = Object.assign(AlertService.prototype, WarningAlertService.prototype);
AlertService.prototype = Object.assign(AlertService.prototype, LoadingAlertService.prototype);

/**
 * Registers Alert events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {BaseService}  service      The service
 * @param      {string}       module_name  The module name
 */
AlertService.prototype.registerAlertEvents = function(self, service) {
  this.registerInfoAlertEvents(self, service);
  this.registerErrorAlertEvents(self, service);
  this.registerSuccessAlertEvents(self, service);
  this.registerQuestionAlertEvents(self, service);
  this.registerWarningAlertEvents(self, service);
  this.registerLoadingAlertEvents(self, service);
  return this;
}

/**
 * Removes Alert events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
AlertService.prototype.removeAlertEvents = function() {
  this.removeInfoAlertEvents();
  this.removeErrorAlertEvents();
  this.removeSuccessAlertEvents();
  this.removeQuestionAlertEvents();
  this.removeWarningAlertEvents();
  this.removeLoadingAlertEvents();
  return this;
}

export default AlertService;